import { Image, Link, Text } from '@chakra-ui/react';

import { JumpingMan } from '../../../assets/Images';
import { CONTACT_US } from '../../../constants/urls';
import { DealType } from '../../../gql/generated/graphql';
import { useHideCobuyer } from '../../../hooks';
import { DealWithFarthestState } from '../utils';
import DashboardStateCard from './DashboardStateCard';

const SoftCloseDashboard = ({ deal }: { deal?: DealWithFarthestState }) => {
  const isRefi = deal?.type === DealType.Refi;
  const isCobuyer = deal?.isCobuyer;
  const hideCobuyer = useHideCobuyer(deal);

  return (
    <DashboardStateCard
      deal={deal}
      header={`Welcome to Your ${isCobuyer && !hideCobuyer ? 'Co-Buyer ' : ''}Dashboard`}
      body={
        <Text mt="10px">
          This is where you'll find updates on your{' '}
          {isRefi ? 'auto refinance status' : 'lease buyout'} as you move forward with our services.
          We'll keep you informed every step of the way.
          <br /> <br />
          If you have any questions or concerns, please don't hesitate to{' '}
          <Link href={CONTACT_US} isExternal>
            reach out to us
          </Link>
          . Our team is here to help you navigate this process.
          <br /> <br />
          Thank you for choosing Lease End — we look forward to working with you!
        </Text>
      }
      image={
        <Image
          p={4}
          src={JumpingMan}
          alt="Jumping Man"
          maxW="250px"
          justifySelf={{ base: 'center', md: 'flex-end' }}
        />
      }
    />
  );
};

export default SoftCloseDashboard;
